"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const WHY_CHOOSE_BASE = "/image/new-version/fabrication/metal-welding/WhyChoose";

const CARDS = [
	{
		keyPrefix: "metalWeldingWhyChooseCard1",
		image: `${WHY_CHOOSE_BASE}/advanced-welding-technology.webp`,
		panelClassName: "bg-[#000000]",
		indexAccentClassName: "text-[#c8e085]",
	},
	{
		keyPrefix: "metalWeldingWhyChooseCard2",
		image: `${WHY_CHOOSE_BASE}/certified-welding-engineering.webp`,
		panelClassName: "bg-[#107e03]",
		indexAccentClassName: "text-[#8fd4a2]",
	},
	{
		keyPrefix: "metalWeldingWhyChooseCard3",
		image: `${WHY_CHOOSE_BASE}/comprehensive-quality-assurance.webp`,
		panelClassName: "bg-[#9ec687]",
		indexAccentClassName: "text-[#d4e8a8]",
	},
] as const;

export default function MetalWeldingWhyChoose() {
	const t = useTranslations("new-welding");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("metalWeldingWhyChooseTitle")}
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
						{t("metalWeldingWhyChooseDesc")}
					</p>
				</header>

				<div className="grid grid-cols-1 gap-6 md:gap-8 lg:grid-cols-3 lg:gap-6">
					{CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className="flex flex-col overflow-hidden border border-gray-200 bg-white shadow-sm"
						>
							<div className="relative aspect-[4/2] w-full bg-[#f5f7fa]">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 100vw, 33vw"
								/>
							</div>
							<div className={`flex flex-1 flex-col px-5 py-6 sm:px-6 sm:py-7 ${card.panelClassName}`}>
								<p
									className={`mb-2 text-sm font-medium tracking-wide sm:mb-3 sm:text-base ${card.indexAccentClassName}`}
								>
									{t(`${card.keyPrefix}Index`)}
								</p>
								<h3 className="mb-2 text-lg font-bold leading-snug text-white sm:mb-3 sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-white/90 md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
